export default function NotImplemented() {
  return (
    <p>This page hasn't been implemented as part of the prototype.</p>
  );
}
